// Bridges the D-pad's DOM buttons (owned by ui.ts, since GameScene has no reason to
// reach into raw DOM) to GameScene's movement state -- same cross-module pattern as
// roomJump.ts/gameReset.ts. Structurally identical to GameScene's own `Facing` type,
// which stays private to that file; TypeScript's structural typing makes a separate
// declaration here unnecessary to share.
export type DpadDirection = 'up' | 'down' | 'left' | 'right';

const directionListeners: Array<(dir: DpadDirection) => void> = [];
const releaseListeners: Array<() => void> = [];

export function onDpadDirection(listener: (dir: DpadDirection) => void): void {
  directionListeners.push(listener);
}

export function onDpadRelease(listener: () => void): void {
  releaseListeners.push(listener);
}

export function triggerDpadDirection(dir: DpadDirection): void {
  directionListeners.forEach((listener) => listener(dir));
}

export function triggerDpadRelease(): void {
  releaseListeners.forEach((listener) => listener());
}
